import React, { useEffect, useState } from "react";
import PlusIcon from "../../assets/icons/plus";
import Popup from "../Common/Popup";
import Input from "../Common/CustomInput";
import RoleTable from "../Common/RoleTable";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import api from "../../setupMiddleware";
import { ToastContainer, toast, Bounce } from "react-toastify";
import Permissions from "../Common/Permissions";
import { Link } from "react-router-dom";

const RoleManagement = () => {
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [roleData, setRoleData] = useState([]);
  const [permissionData, setPermissionData] = useState([]);
  const [roleName, setRoleName] = useState("");
  const [roleEdit, setRoleedit] = useState({});
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  console.log("roleEdit", roleEdit);
  const loading = useApiLoader();

  const getAllRoles = async () => {
    api.get("/api/user-roles").then((res) => {
      if (res && res.status === 200) {
        // const filteredData = res.data.data.filter(
        //   (item) => item.name !== "Admin"
        // );
        setRoleData(res.data?.data);
        setOpen(false);
        setEditOpen(false);
        setDeleteOpen(false);
        setRoleName("");
        setRoleedit({});
        setSelectedPermissions([]);
      }
    });
  };

  const deleteRole = async () => {
    api
      .delete(`/api/user-roles/${roleEdit?.id}`)
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          getAllRoles();
        }
      })
      .catch((err) => {
        if (err) {
          alert(err.response?.data?.errors?.name[0]);
        }
      });
  };

  const handleEditRole = (val) => {
    setRoleedit(val);
    setEditOpen(true);
  };

  const handleDeleteRole = (val) => {
    setRoleedit(val);
    setDeleteOpen(true);
  };

  const getAllPermissions = async () => {
    api.get("/api/permissions").then((res) => {
      if (res && res.status === 200) {
        setPermissionData(res.data);
      }
    });
  };

  useEffect(() => {
    getAllRoles();
    getAllPermissions();
  }, []);

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Role Management
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Manage All Roles
          </span>
        </p>

        {/* Right Button */}
        <div className="flex">
          <Link
            to="/add-role"
            className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
          >
            <PlusIcon iconClass="w-4 h-4" color="#ffffff" />
            Add New Role
          </Link>

          {/* Delete Popup */}
          <Popup
            isOpen={deleteOpen}
            onClose={() => setDeleteOpen(false)}
            title="Delete Role"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">
                  Are you sure and want to delete <b>{roleEdit?.name}</b> role?
                </p>
              </div>
            </div>

            <div className="flex justify-end gap-4">
              <button
                onClick={() => setDeleteOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={deleteRole}
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
              >
                Delete Role
              </button>
            </div>
          </Popup>
        </div>
      </div>

      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                All Roles
              </p>
            </div>
            <RoleTable
              data={roleData}
              handleEdit={handleEditRole}
              handleDelete={handleDeleteRole}
            />
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default RoleManagement;
